import mapboxGl from 'mapbox-gl';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var _navigator$connection;

var config = {
  style: {
    version: 8,
    sources: {
      map: {
        type: 'raster',
        tiles: ["https://maptiles.finncdn.no/tileService/1.0.3/normap/{z}/{x}/{y}.png"],
        tileSize: 256,
        maxzoom: 21
      },
      'map-hd': {
        type: 'raster',
        tiles: ["https://maptiles.finncdn.no/tileService/1.0.3/normaphd/{z}/{x}/{y}.png"],
        tileSize: 256,
        maxzoom: 21
      },
      ortho: {
        type: 'raster',
        tiles: ["https://maptiles.finncdn.no/tileService/1.0.3/norortho/{z}/{x}/{y}.png"],
        tileSize: 256,
        maxzoom: 21
      },
      hybrid: {
        type: 'raster',
        tiles: ["https://maptiles.finncdn.no/tileService/1.0.3/norhybrid/{z}/{x}/{y}.png"],
        tileSize: 256,
        maxzoom: 21
      },
      poi: {
        type: 'vector',
        tiles: ["/api/search/protobuf/{z}/{x}/{y}?autoLimit=true"],
        maxzoom: 21
      }
    },
    glyphs: 'https://static.finncdn.no/_c/new-construction-podlet-fonts/{fontstack}/{range}.pbf',
    layers: [{
      id: 'map',
      type: 'raster',
      // if the user has data saver mode enabled, use the low res tiles
      // @ts-ignore TS doesn't have types for `connection`
      source: ((_navigator$connection = navigator.connection) == null ? void 0 : _navigator$connection.saveData) ? 'map' : 'map-hd'
    }]
  },
  fadeDuration: 50,
  // Disable map rotation
  pitchWithRotate: false,
  dragRotate: false
};

var BOUNDS_FOR_NORWAY = [// sw
{
  lng: 3.6,
  lat: 57.5
}, // ne
{
  lng: 32.1,
  lat: 71.5
}];

var FinnMap = /*#__PURE__*/function (_HTMLElement) {
  _inheritsLoose(FinnMap, _HTMLElement);

  function FinnMap() {
    return _HTMLElement.apply(this, arguments) || this;
  }

  var _proto = FinnMap.prototype;

  _proto.connectedCallback = function connectedCallback() {
    var _this = this;

    // Resist the tempation to move this into the constructor, it'll fail in components like BottomSheet
    if (!this.container) {
      var outer = document.createElement('div');
      outer.className = 'finn-map--outer';
      this.container = document.createElement('div');
      this.container.className = 'finn-map--inner';
      outer.appendChild(this.container);
      this.appendChild(outer);
    }

    this.mapbox = new mapboxGl.Map(_extends({}, config, {
      container: this.container,
      interactive: !this.hasAttribute('static'),
      logoPosition: 'bottom-left',
      bounds: this.initialBounds
    }));
    this.mapbox.addControl(new mapboxGl.AttributionControl({
      customAttribution: '© <a href="https://www.norkart.no/">Norkart</a>',
      // Since the attribution is tiny we don't want to render Mapbox' collapsed version
      compact: false
    }), this.attributionPosition);
    this.mapbox.on('mouseenter', 'point', function () {
      _this.mapbox.getCanvas().style.cursor = 'pointer';
    });
    this.mapbox.on('mouseleave', 'point', function () {
      _this.mapbox.getCanvas().style.cursor = '';
    }); // speed up scrolling when using scroll wheel
    // https://github.com/mapbox/mapbox-gl-js/pull/7863

    this.mapbox.scrollZoom.setWheelZoomRate(1 / 100);
  } // Cleanup/garbage collection
  ;

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.mapbox.remove(); // @ts-ignore

    this.mapbox = undefined;
  };

  _createClass(FinnMap, [{
    key: "attributionPosition",
    get: function get() {
      var position = this.getAttribute('attribution-position'); // @ts-ignore

      return position || 'bottom-right';
    },
    set: function set(position) {
      this.setAttribute('attribution-position', position);
    }
  }, {
    key: "initialBounds",
    get: function get() {
      return this.hasAttribute('initial-bounds') ? // come on ts.. we just checked this
      // @ts-ignore
      JSON.parse(this.getAttribute('initial-bounds')) : BOUNDS_FOR_NORWAY;
    },
    set: function set(bounds) {
      this.setAttribute('initial-bounds', JSON.stringify(bounds));
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['attribution-position'];
    }
  }]);

  return FinnMap;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

export default FinnMap;
export { BOUNDS_FOR_NORWAY };
//# sourceMappingURL=map.esm.js.map
